import { Component, Input, OnInit } from "@angular/core";
import { FlujoVentaPaso } from "../../../_models/flujo-venta-paso";
import { TabViewCustom } from "../../../_models/tab-view-custom";
import { SelectItem } from "primeng/api";
@Component({
  selector: "app-flujo-venta-unidad-productiva",
  templateUrl: "./flujo-venta-unidad-productiva.component.html",
  styleUrls: ["./flujo-venta-unidad-productiva.component.css"],
})
export class FlujoVentaUnidadProductivaComponent implements OnInit {
  @Input() tabView: TabViewCustom;
  @Input() listaSecuencias: SelectItem[] = [];
  @Input() listaVinculaciones: SelectItem[] = [];
  @Input() listaTiposPersonas: SelectItem[] = [];
  @Input() lisPasos: FlujoVentaPaso[] = [];
  @Input() titulo: string;

  tabSeleccionado = "DATGEN";

  constructor() {}

  ngOnInit() {}

  abrirAcordeon(evento: number) {
    switch (evento) {
      case 0: {
        this.tabSeleccionado = "DATGEN";
        break;
      }
      case 1: {
        this.tabSeleccionado = "RESPERXVIN";
        break;
      }
    }
  }
}
